export default __webpack_public_path__ + "static/DadsRecipe-341f50d60046522cf2b4222bde7c29f3.woff2";